import { Pipe, PipeTransform } from "@angular/core";
import { SalePaymentStatusEnum } from "@models/sale";

@Pipe({
  name: "paymentStatus",
  standalone: true,
})
export class PaymentStatusPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case SalePaymentStatusEnum.CANCELADO:
        return "Cancelado";
      case SalePaymentStatusEnum.PAGO:
        return "Pago";
      case SalePaymentStatusEnum.RECEBIVEL:
        return "Recebível";
      case SalePaymentStatusEnum.TRANSFERIDO:
        return "Transferido";
      case SalePaymentStatusEnum.CORTESIA:
        return "Cortesia";
      case SalePaymentStatusEnum.REEMBOLSADO:
        return "Reembolsado";
      default:
        return value;
    }
  }
}
